import React, { memo } from 'react';
import { View, TouchableOpacity, StyleSheet, Text } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin/colors';
import { TAG_PRESET_ICONS } from '@/constants/residents/corkBoardConstants';

interface TagIconPickerProps {
  selectedIcon: string | null;
  onSelectIcon: (icon: string | null) => void;
}

export const TagIconPicker: React.FC<TagIconPickerProps> = memo(({ selectedIcon, onSelectIcon }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.label}>Icon</Text>
      <View style={styles.grid}>
        {TAG_PRESET_ICONS.map((icon) => {
          const isSelected = selectedIcon === icon;
          return (
            <TouchableOpacity
              key={icon}
              style={[styles.iconCell, isSelected && styles.iconCellSelected]}
              onPress={() => onSelectIcon(isSelected ? null : icon)}
              activeOpacity={0.7}
              accessibilityLabel={`Icon ${icon}`}
              accessibilityRole="radio"
              accessibilityState={{ selected: isSelected }}
            >
              <Text style={styles.iconText}>{icon}</Text>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
});

TagIconPicker.displayName = 'TagIconPicker';

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  label: {
    fontSize: 13,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT.SECONDARY,
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  iconCell: {
    width: 40,
    height: 40,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.BORDER,
  },
  iconCellSelected: {
    borderColor: ADMIN_COLORS.PRIMARY,
    borderWidth: 2,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  iconText: {
    fontSize: 20,
  },
});
